export default [
    {
      title: 'menu.Claims',
      icon: 'LifeBuoyIcon',
      tagVariant: 'light-danger',
      route:'claims'
    },
  ]
  